module.exports = __webpack_public_path__ + "img/picto-farmers.afc9d039.svg";